export default __webpack_public_path__ + "static/media/login_left.c29e6679.png";